import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import defaultLogo from "../../assets/planetun.svg";
import { LEGACY_DOMAIN } from "../../shared/constants";
import { getCachedTokenInformation, getTokenInformation, getRemoteLogo } from "../../services/legacyService";

import { useEffect, useState } from "react";
import "./Header.css";

const LOGO_STORAGE_PREFIX = "televistoria:header-logo:";

function canUseSessionStorage() {
  try {
    return typeof window !== "undefined" && !!window.sessionStorage;
  } catch (error) {
    return false;
  }
}

function getLogoStorageKey(token: string) {
  return `${LOGO_STORAGE_PREFIX}${token}`;
}

function readCachedLogo(token: string) {
  if (!token || !canUseSessionStorage()) return "";

  try {
    return window.sessionStorage.getItem(getLogoStorageKey(token)) ?? "";
  } catch (error) {
    console.log(error);
    return "";
  }
}

function saveCachedLogo(token: string, logo: string) {
  if (!token || !logo || !canUseSessionStorage()) return;

  try {
    window.sessionStorage.setItem(getLogoStorageKey(token), logo);
  } catch (error) {
    console.log(error);
  }
}

function buildInferredLogo(clientId?: string) {
  if (!clientId || !LEGACY_DOMAIN) return "";

  return `${LEGACY_DOMAIN}/planetun-v2/sistema/includes/imagens/regulacoes/${clientId}/logo_topo.svg`;
}

function getClientId(response: any) {
  const customerData = Array.isArray(response) ? response[0] : response;
  const clientId = customerData?.ID_CLIENTE;

  return typeof clientId === "string" ? clientId : "";
}

export default function Header(props: { token: string }) {
  const cachedCustomerData = getCachedTokenInformation(props.token);
  const initialLogo =
    readCachedLogo(props.token) || buildInferredLogo(cachedCustomerData?.ID_CLIENTE) || defaultLogo;
  const [logo, setLogo] = useState(initialLogo);

  useEffect(() => {
    let isMounted = true;
    const cachedLogo = readCachedLogo(props.token);

    if (cachedLogo) {
      setLogo(cachedLogo);
      return () => {
        isMounted = false;
      };
    }

    const cacheFromToken = getCachedTokenInformation(props.token);
    const inferredLogo = buildInferredLogo(cacheFromToken?.ID_CLIENTE);
    if (inferredLogo) {
      setLogo(inferredLogo);
    }

    const loadCustomerInformation = async () => {
      try {
        const response = await getTokenInformation(props.token);
        const clientId = getClientId(response);

        if (!clientId) return;

        const remoteLogo = await getRemoteLogo(clientId);

        if (isMounted && remoteLogo) {
          setLogo(remoteLogo);
          saveCachedLogo(props.token, remoteLogo);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (props.token) {
      loadCustomerInformation();
    }

    return () => {
      isMounted = false;
    };
  }, [props.token]);
  // sx={{ top: '2%', position: 'relative' }}
  return (
    <AppBar position='static' elevation={0}>
      <Toolbar
        sx={{
          backgroundColor: "white",
        }}>
        <img alt='Planetun' className='logo' src={logo} />
      </Toolbar>
    </AppBar>
  );
}
